import type { ApiEndpoint, HealthSummary } from '../../api/monitor';
import type { NotificationsController } from '../../hooks/useNotifications';
import { SicopMark } from '../SicopMark';
import { HealthIndicator } from './HealthIndicator';
import { NotificationBell } from './NotificationBell';
import type { ScreenId } from './navigation';
import { Avatar } from './UserBadge';
import type { ShellUser } from './UserBadge';

interface TopBarProps {
  title: string;
  summary: HealthSummary | null;
  apis: ApiEndpoint[];
  user: ShellUser;
  /** Central de notificações do sino; é a mesma da tela de Notificações. */
  notifications: NotificationsController;
  onNavigate: (screen: ScreenId) => void;
}

/**
 * Cabeçalho comum das telas: título, saúde geral das APIs, central de
 * notificações e atalho do perfil.
 */
export function TopBar({
  title,
  summary,
  apis,
  user,
  notifications,
  onNavigate,
}: TopBarProps) {
  return (
    <header className="border-line-200 flex shrink-0 items-center gap-3 border-b bg-white px-[18px] py-3.5">
      <SicopMark size={28} className="desktop:hidden" />

      <h1 className="flex-1 text-[17px] font-extrabold">{title}</h1>

      <HealthIndicator summary={summary} apis={apis} onOpenStatus={() => onNavigate('status')} />

      <NotificationBell
        controller={notifications}
        onOpenAll={() => onNavigate('notifications')}
      />

      <button type="button" onClick={() => onNavigate('profile')} title="Abrir perfil">
        <Avatar name={user.name} picture={user.picture} size={32} />
        <span className="sr-only">Perfil</span>
      </button>
    </header>
  );
}
